import { useEffect } from 'react';

export default (fields, unregister) => {
  useEffect(() => () => {
    unregister(fields);
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [unregister]);
};
